import { useEffect, useState } from "react";
import { Receipt, Check, X, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import api from "@/lib/api";

export default function StorePendingReceipts() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(null);
  const load = () => api.storeReceiptsPending().then(setRows).catch(() => setRows([]));
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const act = async (r, accept) => {
    setBusy(r.id);
    try {
      const res = await api.storeReceiptConfirm(r.id, accept);
      toast.success(accept ? `Scontrino confermato: giocata ${res.play_result === "win" ? `VINCENTE (${res.prize_name})` : "registrata"}, cliente avvisato` : "Segnalato: non è della tua sede");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Operazione non riuscita"); } finally { setBusy(null); }
  };
  if (!rows || rows.length === 0) return null;
  return (
    <Card className="p-5 bg-card border-amber-300 space-y-3" data-testid="store-pending-receipts">
      <div className="flex items-center justify-between gap-2">
        <h3 className="font-display font-bold text-lg flex items-center gap-2"><Receipt className="h-4 w-4 text-amber-600" /> Scontrini da verificare <span className="text-sm font-normal text-muted-foreground">({rows.length})</span></h3>
        <Button size="sm" variant="ghost" className="h-8" onClick={load} data-testid="store-pending-refresh"><RefreshCw className="h-3.5 w-3.5" /></Button>
      </div>
      <p className="text-xs text-muted-foreground">Il sistema non è sicuro che questi scontrini siano stati emessi dalla tua sede. Controlla la foto: se è vostro, conferma e la giocata parte subito.</p>
      {rows.map((r) => {
        const e = r.extracted || {};
        const score = (r.store_match?.candidates || []).find((c) => c.store_id === r.store_match?.store_id)?.score ?? r.store_match?.score ?? 0;
        return (
          <div key={r.id} className="grid gap-3 rounded-lg border border-border p-3 sm:grid-cols-[88px_1fr_auto] items-center" data-testid={`store-pending-${r.id}`}>
            {r.file_id ? <a href={`/api/files/${r.file_id}`} target="_blank" rel="noreferrer"><img src={`/api/files/${r.file_id}`} alt="scontrino" className="h-22 w-22 h-[88px] w-[88px] object-cover rounded-md border border-border bg-white" /></a> : <div className="h-[88px] w-[88px] rounded-md bg-secondary" />}
            <div className="text-xs space-y-0.5 min-w-0">
              <p className="font-semibold">{r.contest_name}</p>
              <p><b>{e.store_name || "Negozio n/d"}</b>{(e.address || e.city) ? ` · ${[e.address, e.zip_code, e.city].filter(Boolean).join(" ")}` : ""}</p>
              <p>{e.date || "data n/d"} {e.time || ""} · Totale <b>{e.total != null ? `${Number(e.total).toFixed(2)} €` : "n/d"}</b>{e.document_number ? ` · Doc. ${e.document_number}` : ""} · somiglianza {Math.round(score * 100)}%</p>
              {e.items?.length > 0 && <p className="text-muted-foreground truncate">{e.items.map((i) => i.name).join(", ")}</p>}
            </div>
            <div className="flex sm:flex-col gap-2">
              <Button size="sm" className="gap-1 bg-emerald-600 hover:bg-emerald-700 text-white" disabled={busy === r.id} onClick={() => act(r, true)} data-testid={`store-pending-accept-${r.id}`}><Check className="h-3.5 w-3.5" /> È nostro</Button>
              <Button size="sm" variant="outline" className="gap-1 border-border" disabled={busy === r.id} onClick={() => act(r, false)} data-testid={`store-pending-decline-${r.id}`}><X className="h-3.5 w-3.5" /> Non è nostro</Button>
            </div>
          </div>
        );
      })}
    </Card>
  );
}
